export const formLabelClass = 'block text-sm font-medium text-slate-300 mb-2';
